import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import "./Explore.css";

const Explore = ({
  placeholderText = "Explore Page (Coming Soon)",
  title = "Explore Content",
}) => {
  const location = useLocation();
  const iframeUrl = location.state?.url;
  const [isIframeLoaded, setIsIframeLoaded] = useState(false);

  useEffect(() => {
    setIsIframeLoaded(false);
  }, [iframeUrl]);

  // Apply loaded class only after the iframe has fully loaded
  useEffect(() => {
    const root = document.documentElement;
    if (iframeUrl && isIframeLoaded) {
      document.body.classList.add("iframe-loaded");
      root.classList.add("iframe-loaded");
    } else {
      document.body.classList.remove("iframe-loaded");
      root.classList.remove("iframe-loaded");
    }

    // Cleanup on unmount
    return () => {
      document.body.classList.remove("iframe-loaded");
      root.classList.remove("iframe-loaded");
    };
  }, [iframeUrl, isIframeLoaded]);

  return (
    <div className="explore-page">
      {iframeUrl ? (
        <iframe
          src={iframeUrl}
          className="explore-iframe"
          title={title}
          onLoad={() => setIsIframeLoaded(true)}
          allowFullScreen
          allow="microphone"
          sandbox="allow-scripts allow-same-origin allow-forms allow-popups allow-popups-to-escape-sandbox"
        />
      ) : (
        <div className="explore-content">
          <div style={{ padding: "20px", textAlign: "center" }}>
            {placeholderText}
          </div>
        </div>
      )}
    </div>
  );
};

export default Explore;
